import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import './NoticeDetail.css';

const NoticeDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [notice, setNotice] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchNotice();
	}, [id]);

	const fetchNotice = async () => {
		try {
			const response = await fetch(`${API_BASE_URL}/products/notices/${id}/`);
			
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			
			const data = await response.json();
			setNotice(data);
		} catch (error) {
			console.error('공지사항 로딩 실패:', error);
		} finally {
			setLoading(false);
		}
	};

	if (loading) return <div className="notice-detail-loading">로딩 중...</div>;
	if (!notice) return <div className="notice-detail-error">공지사항을 찾을 수 없습니다.</div>;

	return (
		<div className="notice-detail-container">
			<div className="notice-detail-header">
				{notice.is_pinned && <span className="badge-pinned">📌 공지</span>}
				<h1>{notice.title}</h1>
				<span className="notice-detail-date">
					{new Date(notice.created_at).toLocaleDateString('ko-KR')}
				</span>
			</div>

			<div className="notice-detail-content">
				<p style={{ whiteSpace: 'pre-wrap' }}>{notice.content}</p>
			</div>

			<button onClick={() => navigate('/notice')} className="btn-back">
				목록으로
			</button>
		</div>
	);
};

export default NoticeDetail;